<script lang="ts">
  import clsx from 'clsx';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import type { HeadingXSmallProps } from './types';
  let { class: className, size = 'xsmall', ...props }: HeadingXSmallProps = $props();
</script>

<BaseHeading class={clsx(className)} {size} level={4} {...props} />
